// Calendar helpers — .ics works on Apple/Android/Outlook; Google link covers web users.

function pad(n) {
  return String(n).padStart(2, "0");
}

function toDateParts(event) {
  if (!event.start_date) return null;
  const [y, m, d] = event.start_date.split("-").map(Number);
  if (!y || !m || !d) return null;
  const start = event.start_time ? event.start_time.split(":").map(Number) : null;
  const end = event.end_time ? event.end_time.split(":").map(Number) : null;
  return { y, m, d, sh: start?.[0], sm: start?.[1], eh: end?.[0], em: end?.[1] };
}

function esc(text) {
  return String(text || "").replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");
}

function buildDescription(event) {
  const parts = [event.description, "", `Details & registration: ${window.location.origin}/events/${event.id}`];
  if (Number(event.price) > 0) parts.push(`Tickets: $${Number(event.price).toFixed(2)} per attendee`);
  return parts.filter(Boolean).join("\n");
}

export function icsForEvent(event) {
  const p = toDateParts(event);
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//AB Hunter Consulting USA//Events//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${event.id}@abhunter.us`,
    `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, "").split(".")[0]}Z`,
  ];
  if (p && p.sh != null) {
    lines.push(`DTSTART:${p.y}${pad(p.m)}${pad(p.d)}T${pad(p.sh)}${pad(p.sm || 0)}00`);
    if (p.eh != null) lines.push(`DTEND:${p.y}${pad(p.m)}${pad(p.d)}T${pad(p.eh)}${pad(p.em || 0)}00`);
  } else if (p) {
    lines.push(`DTSTART;VALUE=DATE:${p.y}${pad(p.m)}${pad(p.d)}`);
    const next = new Date(Date.UTC(p.y, p.m - 1, p.d + 1));
    lines.push(`DTEND;VALUE=DATE:${next.getUTCFullYear()}${pad(next.getUTCMonth() + 1)}${pad(next.getUTCDate())}`);
  }
  lines.push(`SUMMARY:${esc(event.title)}`);
  if (event.location) lines.push(`LOCATION:${esc(event.location)}`);
  lines.push(`DESCRIPTION:${esc(buildDescription(event))}`);
  lines.push("END:VEVENT", "END:VCALENDAR");
  return lines.join("\r\n");
}

export function downloadIcs(event) {
  const blob = new Blob([icsForEvent(event)], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${event.title.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function googleCalUrl(event) {
  const p = toDateParts(event);
  let dates = "";
  if (p && p.sh != null) {
    const start = `${p.y}${pad(p.m)}${pad(p.d)}T${pad(p.sh)}${pad(p.sm || 0)}00`;
    const endH = p.eh != null ? p.eh : p.sh + 2;
    const end = `${p.y}${pad(p.m)}${pad(p.d)}T${pad(endH)}${pad(p.em || 0)}00`;
    dates = `${start}/${end}`;
  } else if (p) {
    const next = new Date(Date.UTC(p.y, p.m - 1, p.d + 1));
    dates = `${p.y}${pad(p.m)}${pad(p.d)}/${next.getUTCFullYear()}${pad(next.getUTCMonth() + 1)}${pad(next.getUTCDate())}`;
  }
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: event.title,
    details: buildDescription(event),
    location: event.location || "",
  });
  if (dates) params.set("dates", dates);
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
